import { render, staticRenderFns } from "./tab2AssignStudents.vue?vue&type=template&id=38a386d0&scoped=true"
import script from "./tab2AssignStudents.vue?vue&type=script&lang=js"
export * from "./tab2AssignStudents.vue?vue&type=script&lang=js"
import style0 from "./tab2AssignStudents.vue?vue&type=style&index=0&id=38a386d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a386d0",
  null
  
)

export default component.exports